var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MultichainActionType } from '@popup/multichain/actions/action-type.enum';
import { SteemActionType } from '@popup/steem/actions/action-type.enum';
import { SteemEngineUtils } from '@popup/steem/utils/steem-engine.utils';
import TokensUtils from '@popup/steem/utils/tokens.utils';
import { MessageType } from '@reference-data/message-type.enum';
import { OperationsHiveEngine, } from 'src/interfaces/tokens.interface';
import Logger from 'src/utils/logger.utils';
export const loadTokens = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    let tokens;
    try {
        tokens = yield TokensUtils.getAllTokens();
    }
    catch (err) {
        if (err.message.includes('timeout')) {
            dispatch({
                type: MultichainActionType.SET_MESSAGE,
                payload: { key: 'html_popup_tokens_timeout', type: MessageType.ERROR },
            });
        }
        throw err;
    }
    const action = {
        type: SteemActionType.LOAD_TOKENS,
        payload: tokens,
    };
    dispatch(action);
});
export const loadTokensMarket = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const tokensMarket = yield TokensUtils.getTokensMarket({}, 1000, 0, []);
    const action = {
        type: SteemActionType.LOAD_TOKENS_MARKET,
        payload: tokensMarket,
    };
    dispatch(action);
});
export const loadPendingUnstaking = (account) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const pendingUnstaking = yield TokensUtils.getPendingUnstakes(account);
    const action = {
        type: SteemActionType.LOAD_PENDING_UNSTAKING,
        payload: pendingUnstaking,
    };
    dispatch(action);
});
export const loadUserTokens = (account) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        dispatch({
            type: SteemActionType.CLEAR_USER_TOKENS,
        });
        let tokensBalance = yield TokensUtils.getUserBalance(account);
        tokensBalance = tokensBalance.sort((a, b) => parseFloat(b.balance) - parseFloat(a.balance));
        const action = {
            type: SteemActionType.LOAD_USER_TOKENS,
            payload: tokensBalance,
        };
        dispatch(action);
    }
    catch (e) {
        Logger.error(e);
    }
});
export const loadTokenHistory = (account, currency) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch({ type: SteemActionType.INIT_TOKEN_HISTORY });
    const action = yield getHistory(account, currency, 0);
    dispatch(action);
});
export const fetchMoreTokenHistory = (account, currency) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch({ type: SteemActionType.IS_LOADING });
    const offset = getState().steem.tokenHistory.list.length;
    const action = yield getHistory(account, currency, offset);
    dispatch(action);
});
const getHistory = (account, currency, offset) => __awaiter(void 0, void 0, void 0, function* () {
    let tokenHistory = [];
    let start = offset;
    let previousTokenHistoryLength = 0;
    const limit = 500;
    do {
        previousTokenHistoryLength = tokenHistory.length;
        let result = yield SteemEngineUtils.getHistory(account, currency, start);
        start += limit;
        tokenHistory = [...tokenHistory, ...result];
    } while (previousTokenHistoryLength !== tokenHistory.length &&
        tokenHistory.length < 1000);
    tokenHistory = tokenHistory.map((t) => {
        t.amount = `${t.quantity} ${t.symbol}`;
        switch (t.operation) {
            case OperationsHiveEngine.COMMENT_CURATION_REWARD:
            case OperationsHiveEngine.COMMENT_AUTHOR_REWARD:
                return Object.assign(Object.assign({}, t), { authorPerm: t.authorperm });
            case OperationsHiveEngine.MINING_LOTTERY:
                return Object.assign(Object.assign({}, t), { poolId: t.poolId });
            case OperationsHiveEngine.TOKENS_TRANSFER:
                return Object.assign(Object.assign({}, t), { from: t.from, to: t.to, memo: t.memo });
            case OperationsHiveEngine.TOKEN_STAKE:
                return Object.assign(Object.assign({}, t), { from: t.from, to: t.to });
            case OperationsHiveEngine.TOKENS_DELEGATE:
                return Object.assign(Object.assign({}, t), { delegator: t.from, delegatee: t.to });
            case OperationsHiveEngine.TOKEN_UNDELEGATE_START:
            case OperationsHiveEngine.TOKEN_UNDELEGATE_DONE:
                return Object.assign(Object.assign({}, t), { delegator: t.to, delegatee: t.from });
            default:
                return t;
        }
    });
    const action = {
        type: start === 0
            ? SteemActionType.LOAD_TOKEN_HISTORY
            : SteemActionType.FETCH_MORE_TOKEN_HISTORY,
        payload: {
            transactions: tokenHistory,
            shouldLoadMore: previousTokenHistoryLength !== tokenHistory.length,
        },
    };
    return action;
});
